var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#facebook-icon)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.1545 0H3.29283C1.57501 0 0.182373 1.44791 0.182373 3.23405V20.7658C0.182373 22.552 1.57495 23.9999 3.29283 23.9999H11.6089L11.6231 15.4236H9.48014C9.20164 15.4236 8.97561 15.1895 8.97454 14.8999L8.96426 12.1354C8.96319 11.8443 9.1899 11.6077 9.46992 11.6077H11.609V8.93651C11.609 5.83661 13.4299 4.14869 16.0895 4.14869H18.2719C18.5511 4.14869 18.7776 4.38406 18.7776 4.67444V7.00547C18.7776 7.29573 18.5513 7.53104 18.2722 7.53122L16.9329 7.53187C15.4865 7.53187 15.2064 8.24648 15.2064 9.29522V11.6078H18.3846C18.6874 11.6078 18.9224 11.8827 18.8867 12.1954L18.5716 14.9599C18.5414 15.2244 18.3257 15.4237 18.0695 15.4237H15.2206L15.2064 24H20.1546C21.8724 24 23.265 22.5521 23.265 20.766V3.23405C23.2649 1.44791 21.8724 0 20.1545 0Z",
    fill: "#475993"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "facebook-icon"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23.0828,
    height: 24,
    fill: "white",
    transform: "translate(0.182251)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.1d3139c5.svg";
export { ForwardRef as ReactComponent };